import {forEach} from "lodash";

(function () {
    function tableSorting() {
        let cells = document.querySelectorAll(".sortable-table th");

        // loop through the cells
        document.querySelectorAll(".sortable-table th").forEach(function(cell) {
            cell.addEventListener("click", function() {
                let table = this.closest('table');
                let tbody = table.querySelectorAll('tbody')[0];
                let rowsArray = Array.from(table.querySelectorAll('tr:not(:first-child)'));
                let cellIndex = Array.from(this.parentNode.children).indexOf(this);
                let asc = this.asc = !this.asc;

                rowsArray.sort(function(rowA, rowB) {
                    let valA = rowA.cells[cellIndex].textContent.trim();
                    let valB = rowB.cells[cellIndex].textContent.trim();
                    return valA.localeCompare(valB, undefined, {numeric: true}) * (asc ? 1 : -1);
                });

                rowsArray.forEach(function(row) {
                    tbody.appendChild(row); // or use insertBefore for more complex scenarios
                });
            });
        });



        function comparer(index) {
            return function (a, b) {
                let valA = getCellValue(a, index), valB = getCellValue(b, index);
                return $.isNumeric(valA) && $.isNumeric(valB) ? valA - valB : valA.toString().localeCompare(valB);
            };
        }

        function getCellValue(row, index) {
            return row.children('td').eq(index).innerText;
        }
    }

    function rowExpanderListener() {
        let items = document.getElementsByClassName("testing-register-row-expander");
        forEach(items, function (item) {
            item.addEventListener('click', function (ev) {
                ev.preventDefault;
                this.classList.toggle("testing-register-row-expander-open");
                this.closest('tr').querySelectorAll('.testing-register-td-inner').forEach(element => element.classList.toggle("testing-register-td-inner-show-overflow"));
                return false;
            });
        });
    }

    function tableColumnListener() {
        let items = document.getElementsByClassName("testing-register-dropdown-checkbox");
        forEach(items, function (item) {

            item.addEventListener('change', function () {
                toggleTableColumn(this);
            });
        });
    }

    function toggleTableColumn(el) {
        let column = el.dataset.column;
        if (el.checked) { // Using the `checked` property instead of jQuery's `is(':checked')`
            document.querySelectorAll(".testing-register-table tr > :nth-child(" + column + ")").forEach(function (cell) {
                cell.style.display = "";
            });
        } else {
            document.querySelectorAll(".testing-register-table tr > :nth-child(" + column + ")").forEach(function (cell) {
                cell.style.display = "none";
            });
        }
        el.preventDefault;
    }

    document.addEventListener("DOMContentLoaded", function () {
        tableSorting();
        rowExpanderListener();
        tableColumnListener();
    });
})();
